import type { ViewApi } from "@fullcalendar/core";
import { ref } from "vue";

import type { FullEvent } from "@ctrl/controller-rpc";

const id = "staticGhostEvent";

export const useStaticGhostEvent = () => {
  const hasEventCopy = ref(false);
  const createStaticGhostEvent = (event: FullEvent, view: ViewApi) => {
    if (hasEventCopy.value) return;
    const { title, start, end, allDay, calendar, task } = event;
    view.calendar.addEvent({
      id,
      title,
      start,
      end,
      allDay,
      extendedProps: {
        calendarId: calendar,
        // Preserve allocation nature so wrapper can render checkbox
        taskId: task,
      },
    });
    hasEventCopy.value = true;
  };
  const removeStaticGhostEvent = (view: ViewApi) => {
    if (!hasEventCopy.value) return;
    view.calendar.getEventById(id)?.remove();
    hasEventCopy.value = false;
  };
  return {
    createStaticGhostEvent,
    removeStaticGhostEvent,
  };
};

export const handleStaticGhostEvent = (el: HTMLElement): void => {
  if (!el.parentElement) return;
  const hasNonZeroPercentages = el.parentElement.style.inset
    .match(/(\d+)%/g)
    ?.filter((match) => match !== "0%");

  if (hasNonZeroPercentages) {
    const inset = el.parentElement.style.inset;
    el.parentElement.style.inset = inset.replace("50%", "0%");
  }
  el.style.opacity = "0.6";
};

export const isStaticGhostEvent = (eventId: string | undefined): boolean =>
  eventId === id;
